import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../features/auth/context/AuthContext";
import LoadingScreen from "../ui/loading/LoadingScreen";
import { ROUTES } from "../../core/config";

interface Props {
    children: React.ReactNode;
}

export const AuthGuard = ({ children }: Props) => {
    const { user, status } = useAuth();
    const location = useLocation();

    if (status === "initializing") {
        return <LoadingScreen text="Vérification de votre session..." />;
    }

    if (!user) {
        return (
            <Navigate
                to={ROUTES.AUTH_ROUTES.LOGIN}
                replace
                state={{ from: location.pathname }}
            />
        );
    }

    return <>{children}</>;
};